import { Component, OnInit, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { BadaService } from 'src/app/services/bada.service';
import { VehicleInfo } from 'src/app/models/vehicle-info';
import { VehicleVersion } from 'src/app/models/vehicle-version';
import { VehicleEquipmentStatusEnum, VehicleEquipment } from 'src/app/models/vehicle-equipment';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ReportService } from 'src/app/services/report.service';
import { MatInput } from '@angular/material/input';
import { WebcarService } from 'src/app/services/webcar.service';

@Component({
  selector: 'app-vehicle-identity',
  templateUrl: './vehicle-identity.component.html',
  styleUrls: ['./vehicle-identity.component.css']
})
export class VehicleIdentityComponent implements OnInit {

  vehicleInfo: VehicleInfo = new VehicleInfo();
  vehicleVersionSelected: VehicleVersion = new VehicleVersion();
  /* equipaggiamenti */
  vehicleSeriesEquip: VehicleEquipment [] = [];
  vehicleOptionalEquip: VehicleEquipment [] = [];
  vehicleOptionalEquipmentsChecked: VehicleEquipment[] = [];
  VehicleEquipmentStatusEnum = VehicleEquipmentStatusEnum;

  @ViewChildren(MatInput) matInputs: QueryList<any>;

  constructor(private badaService: BadaService, private reportService: ReportService, private cdref: ChangeDetectorRef, private webcarService: WebcarService) {
    this.vehicleInfo = this.badaService.vehicleInfo.getValue();
    this.vehicleVersionSelected = this.badaService.vehicleVersionSelected;
    this.vehicleSeriesEquip = this.vehicleVersionSelected.equipmentsAll.filter(equip => equip.status == VehicleEquipmentStatusEnum.Series);
    this.vehicleOptionalEquip = this.vehicleVersionSelected.equipmentsAll.filter(equip => equip.status == VehicleEquipmentStatusEnum.Optional || equip.status == VehicleEquipmentStatusEnum.Unknown);
  }

  ngOnInit(): void {  }

  ngAfterViewInit(): void {
    /**
     * Disabilitazione degli input già valorizzati
     */
    this.matInputs.forEach(input => {
      if (input && input.ngControl) {
        input.ngControl.model? input._readonly = true : input._readonly = false;
      }
    })
    this.cdref.detectChanges();
  }

  /**
   * Funzione scatenata sul cambio delle checkbox degli equipaggiamenti
   */
  onOptionalEquipChange(equip: VehicleEquipment, evt: MatCheckboxChange): void {
    if (evt && evt.checked) {
      this.vehicleOptionalEquipmentsChecked.push(equip);
    }
    else {
      const i = this.vehicleOptionalEquipmentsChecked.findIndex(opt => opt.code == equip.code);
      this.vehicleOptionalEquipmentsChecked.splice(i, 1)
    }
  }

  /**
   * Generazione del report carta d'identità del veicolo
   */
  generateVic(): void {
    const vehicleIdentityCardReport: VehicleIdentityCardReport =
    {
      vehicleDescription: this.vehicleVersionSelected.description? this.vehicleVersionSelected.description : null,
      productionCountry: this.vehicleVersionSelected.productionCountry? this.vehicleVersionSelected.productionCountry : null,
      plate: this.vehicleInfo.vehiclePlate? this.vehicleInfo.vehiclePlate : null,
      chassisCode: this.vehicleInfo.chassisCode? this.vehicleInfo.chassisCode : null,
      registrationDate: this.vehicleInfo.registrationDate? this.vehicleInfo.registrationDate.toLocaleString() : null,
      transmission: this.vehicleVersionSelected.transmission? this.vehicleVersionSelected.transmission : null,
      engineCapacity: this.vehicleVersionSelected.engineCapacity? this.vehicleVersionSelected.engineCapacity : null,
      cv: this.vehicleVersionSelected.horsepower? this.vehicleVersionSelected.horsepower : null,
      kw: this.vehicleVersionSelected.kilowatt? this.vehicleVersionSelected.kilowatt : null,
      newPriceList: this.vehicleVersionSelected.quotes.newPriceList? this.vehicleVersionSelected.quotes.newPriceList : null,
      vehicleQuote: this.vehicleVersionSelected.quotes.sellVehicleQuote? this.vehicleVersionSelected.quotes.sellVehicleQuote : null,
      theoreticalKilometers: this.vehicleVersionSelected.quotes.theoreticalKilometers? this.vehicleVersionSelected.quotes.theoreticalKilometers : null,
      vehicleBodyStatus: this.vehicleVersionSelected.vehicleBodyStatus? this.vehicleVersionSelected.vehicleBodyStatus : null,
      vehicleInternalStatus: this.vehicleVersionSelected.vehicleInternalStatus? this.vehicleVersionSelected.vehicleInternalStatus : null,
      vehicleEngineStatus: this.vehicleVersionSelected.vehicleEngineStatus? this.vehicleVersionSelected.vehicleEngineStatus : null,
      effectiveKilometers: this.vehicleVersionSelected.effectiveKilometers? this.vehicleVersionSelected.effectiveKilometers : null,
      customVehicleQuote: this.vehicleVersionSelected.effectiveVehicleQuote? this.vehicleVersionSelected.effectiveVehicleQuote : null,
      seriesEquipments: this.vehicleSeriesEquip? this.vehicleSeriesEquip.map(equip => equip.description) : null,
      optionalEquipments: this.vehicleOptionalEquipmentsChecked? this.vehicleOptionalEquipmentsChecked.map(equip => equip.description) : null,
    }

    this.reportService.sendJsonReportToStimulsoft(vehicleIdentityCardReport).subscribe(_ => {
      const blob = new Blob([_], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
      /*
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        this.webcarService.sendEmail('andrea.dellamaggiora@system-data.it', this.vehicleInfo.vehiclePlate).subscribe(res => {
          console.log(res);
        }, err => {
          console.log(err);
        })
      }
      */
    })
  }

}


export interface VehicleIdentityCardReport {
  vehicleDescription: string;
  plate: string;
  registrationDate: string;
  vehicleQuote: number;
  customVehicleQuote: number;
  theoreticalKilometers: number;
  effectiveKilometers: number;
  chassisCode: string;
  cv: string;
  kw: string;
  engineCapacity: string;
  productionCountry: string;
  transmission: string;
  newPriceList: number;
  vehicleBodyStatus: number;
  vehicleInternalStatus: number;
  vehicleEngineStatus: number;
  seriesEquipments: string [];
  optionalEquipments: string [];
}
